import moment from "moment";
import "moment/locale/fr";

const euroFormatter = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });

/** Montant en euros au format français (ex. 1 234,50 €). */
export const formatEuro = (value: number | null | undefined): string =>
    value == null || Number.isNaN(value) ? "-" : euroFormatter.format(value);

/**
 * Durée stockée en DEMI-HEURES (PunctualCourse.duration) affichée en heures,
 * arrondie à la minute (ex. 5 demi-heures : 2h30).
 */
export const formatHalfHours = (halfHours: number | null | undefined): string => {
    if (!halfHours) return "0h";
    const totalMinutes = Math.round(halfHours * 30);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return minutes ? `${hours}h${String(minutes).padStart(2, "0")}` : `${hours}h`;
};

/** Distance en kilomètres au format français (ex. 72,4 km). */
export const formatKm = (value: number | null | undefined): string =>
    value == null || Number.isNaN(value) ? "-" : `${value.toLocaleString("fr-FR", { maximumFractionDigits: 1 })} km`;

/** Date ISO affichée en français (ex. 18 sept. 2026), tiret si absente. */
export const formatDate = (value: string | null | undefined, format = "DD MMM YYYY"): string =>
    value ? moment(value).locale("fr").format(format) : "-";

/**
 * Description renvoyée par l'URSSAF, rendue lisible : « DP » devient
 * « demandes de paiement » et un horodatage « 15/10/2026 11:17:27 » devient
 * « 15/10/2026 à 11h17 ». Le reste du texte est conservé tel quel.
 */
export const formatUrssafDescription = (description: string | null | undefined): string | null => {
    if (!description) return null;
    return description
        .replace(/\bDP\b/g, "demandes de paiement")
        .replace(/(\d{2}\/\d{2}\/\d{4})[ T](\d{2}):(\d{2})(?::\d{2})?/g, "$1 à $2h$3")
        .replace(/\s+/g, " ")
        .trim();
};
